import type { PartyItem, PartySearchResponse } from "../types/party.types";
import { api } from "./axiosClient";

export const partyApi = {
  searchParty: async (payload: any) => {
    const response = await api.post<PartySearchResponse>(
      "/party/Search",
      payload,
    );
    return response.data;
  },

  createParty: async (data: Partial<PartyItem>) => {
    const response = await api.post("/party/create", data);
    return response.data;
  },

  updateParty: async (data: Partial<PartyItem>) => {
    const response = await api.post("/party/edit", data);
    return response.data;
  },

  activateParty: async (id: string) => {
    return await api.post("/party/change", {
      id,
      isActive: true,
    });
  },

  deActivateParty: async (id: string) => {
    return await api.post("/party/change", {
      id,
      isActive: false,
    });
  },

  removeParty: async (id: string) => {
    return await api.post("/party/remove", { id });
  },
};
